(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sidebar-list-filter"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.sidebarFilterMoreBound) return;
    window.sidebarFilterMoreBound = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-filter-more]');
      if (!button) return;
      event.preventDefault();
      var filter = button.closest('.sidebar-filter');
      if (!filter) return;
      var expanded = filter.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
